import React from 'react'

const ProfileSection = props => <div className="mb-14 flex flex-col w-full" {...props} />

export default ProfileSection
